import { createRowId } from '../ids';

import { createTileDraftLabel } from './tiles';
import type { SpendPointsPayloadBuilderState, SpendPointsWaysToBoostTile } from './types';

export function createDefaultSpendPointsTile(
  draftLabel = createTileDraftLabel(0),
  overrides: Partial<Omit<SpendPointsWaysToBoostTile, 'draftId' | 'draftLabel'>> = {},
): SpendPointsWaysToBoostTile {
  return {
    draftId: createRowId(),
    draftLabel,
    endAt: '2030-12-31T23:59',
    ctaUrl: '',
    imageId: '',
    startAt: '2026-01-01T00:00',
    enabledRegions: [],
    isActive: true,
    title: '',
    ctaLabel: '',
    description: '',
    ...overrides,
  };
}

export function createDefaultSpendPointsState(): SpendPointsPayloadBuilderState {
  return {
    mode: 'spendPoints',
    waysToBoostTiles: [
      createDefaultSpendPointsTile(createTileDraftLabel(0), {
        ctaUrl: 'https://test-customer.luxuryescapes.com/au',
        imageId: 'spend-points-LE-booking-2923ef7e8e5e',
        title: 'Luxury Escapes bookings',
        ctaLabel: 'Browse latest offers',
        description:
          'Earn Société points every time you book — on hotels, tours, cruises, flights and more. The more you travel, the more you earn.',
      }),
      createDefaultSpendPointsTile(createTileDraftLabel(1), {
        ctaUrl: 'https://test-customer.luxuryescapes.com/societe/offers',
        imageId: 'spend-points-partner-offers-d51430b3c677',
        title: 'Partner & Limited time Offers',
        ctaLabel: 'View all offers',
        description:
          "Earn bonus points through our partner brands and limited time promotions. Keep an eye out — these offers change regularly and won't last long.",
      }),
    ],
  };
}
